import React from 'react';
import PropTypes from 'prop-types';
import CustomerPanel from '@/business-components/sale/customers/OrderPanel';
import LeadReplenish from '@/business-components/sale/customers/LeadReplenish';
import AccountPanel from '@/business-components/sale/customers/AccountPanel';
import ActionRecordPanel from '@/pages/leads/actionRecords/ActionRecordPanel';
import DockedDialog from '@/components/DockedDialog';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import ContactPanel from '@/business-components/sale/customers/ContactPanel';
import { isContain } from '@/utils/ParamUtils';
import fePerms from '@/common/permissions/sale/fePerms';
import MessageBox from '@/components/MessageBox';
import OrderPanel from './OrderPanel';
import _ from 'lodash';
import ReviewPanel from './ReviewPanel';
import CustomerFollowUpRecord from '@/business-components/sale/customers/CustomerFollowUpRecord';
import { getQuery } from '@/utils';

class OrderDetails extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        leadId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    order: PropTypes.object,
    onEdit: PropTypes.func,
  }
  state = {}
  componentDidMount() {
    this.fetchOrder();
  }
  fetchOrder = () => {
    const {
      webApi,
      id,
    } = this.props;
    const leadId = this.props.match?.params?.leadId || id;
    const agencyId = getQuery("agencyId");
    webApi
      .getOrder(leadId, agencyId)
      .dispatchJson(ActionTypes.FETCH_ORDER)
      .then((res) => {
        this.setState({ order: res });
      })
      .catch((error) => {
        this.context.error("订单详情获取失败", error.message);
      })
  }
  fetchOrderAndActionList = () => {
    const {
      webApi,
      match: {
        params: { leadId },
      },
    } = this.props;
    const agencyId = getQuery("agencyId");
    webApi
      .getOrder(leadId, agencyId)
      .dispatchJson(ActionTypes.FETCH_ORDER)
      .catch((error) => {
        this.context.error("订单详情获取失败", error.message);
      });
    this.subActionRecordList.fetchActionRecordList();
  }

  render() {
    const { hide } = this.props;
    const { order } = this.state;
    console.log("order: ", order);
    if (!order) {
      return null;
    }
    const readOnly = !isContain(order.permissions, fePerms.ORDER_EDIT);
    const orderReadOnly = !isContain(order.permissions, fePerms.ORDER_INFO_EDIT);
    return (
      <DockedDialog show={!hide} className="OrderDetails" title="订单详情" escHide={true} cancelButton={false} submitLabel={"关闭"} onSubmit={this.handleSubmit} onClose={this.handleClose} onCancel={this.handleClose}>
        {this.renderCustomerInfo(order, readOnly)}
        {this.renderLeadReplenish(order, readOnly)}
        {this.renderContactList(order, readOnly)}
        {this.renderAccountInfo(order)}
        {this.renderCustomerFollowUpRecord(order)}
        {this.renderOrderInfo(order, orderReadOnly)}
        {this.renderReviewInfo(order)}
        {this.renderActionRecordList(order, readOnly)}
      </DockedDialog>
    )
  }

  onRef = (ref) => {
    this.subActionRecordList = ref;
  }

  renderCustomerInfo(order, readOnly) {
    return <CustomerPanel detail={order} ascriptionOwnerId={order.ownerId} ascriptionTeamId={order.ownerTeamIdWhenPaymentConfirmed} lead={order.lead} registrationTicketId={order.lastRegistrationTicketId} readOnly={readOnly} onEdit={this.handleEdit} onChange={this.fetchOrder} />;
  }

  renderLeadReplenish(order, readOnly) {
    return <LeadReplenish detail={order} />;
  }

  renderContactList(order, readOnly) {
    return <ContactPanel lead={{ ...order.lead, additionalLeads: order.additionalLeads }} readOnly={true} getDetail={this.fetchOrder} editPerm={!readOnly} />;
  }

  renderAccountInfo(order) {
    return <AccountPanel detail={order} isOrder lead={order.lead} registrationTicketId={order.lastRegistrationTicketId} callback={this.fetchOrder} />;
  }

  /**
   * @description: 客保跟进记录
   */
  renderCustomerFollowUpRecord = (order) => {
    return <CustomerFollowUpRecord lead={order.lead} />;
  }

  renderActionRecordList(order, readOnly) {
    const linkToAccountOpening = isContain(order.permissions, fePerms.REGISTRATION_DETAIL);
    return <ActionRecordPanel lead={order.lead} potential={order.potential} order={order} readOnly={readOnly} onRef={this.onRef} linkToAccountOpening={linkToAccountOpening} onChange={this.fetchOrder} />;
  }

  //渲染order信息
  renderOrderInfo(order, readOnly) {
    return <OrderPanel lead={order.lead} readOnly={readOnly} onChange={this.fetchOrderAndActionList} />;
  }

  renderReviewInfo(order) {
    return <ReviewPanel paymentOrderApplyRecord={order.paymentOrderApplyRecord} onlineOrderApplyRecord={order.onlineOrderApplyRecord} />;
  }

  handleEdit = () => {
    const { history } = this.props;
    const pathname = history.location.pathname;
    history.push({ pathname: pathname + "/update-lead" });
  }

  handleSubmit = () => {
    this.handleClose();
  }

  handleClose = () => {
    if (this.props.handleClose) {
      return this.props.handleClose();
    }
    const { history } = this.props;
    const pathname = history.location.pathname;
    history.push({ pathname: pathname.substr(0, pathname.lastIndexOf("/")) });
  }
}

function mapStateToProps(state, ownProps) {
  const {
    id,
  } = ownProps;
  const leadId = ownProps.match?.params?.leadId || id;
  return {
    order: state.orderRepo[leadId],
  };
}

export default withApi(connect(mapStateToProps)(OrderDetails));

OrderDetails.contextType = MessageBox;
